import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-118" data-mp="3peam4j0ug885">
      {visible && <motion.div initial={{
      y: 90
    }} animate={{
      y: 0
    }} exit={{
      y: 90
    }} transition={{
      duration: 0.3,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t-2 border-chartreuse/50 bg-abyss/95 px-4 py-3 backdrop-blur" data-id="element-119" data-mp="3ud545iqzlsr7">
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-4" data-id="element-120" data-mp="c6h4w9imbztg">
            <div className="min-w-0" data-id="element-121" data-mp="gxh09ac3a9tu">
              <p className="truncate font-cond text-base uppercase tracking-wide text-bone" data-id="element-122" data-mp="gyilg7mtkcpa">
                Pack Pro-Series 30 pzas ·{' '}
                <span className="text-chartreuse" data-id="element-123" data-mp="73jefc7hz12i">$399 MXN</span>
              </p>
              <p className="truncate font-body text-xs text-ash" data-id="element-124" data-mp="24pwn7l6gnwj">
                Lote limitado · garantía de 2 salidas
              </p>
            </div>
            <CtaButton size="md" source="barra-fija" className="shrink-0" data-id="element-125" data-mp="c4p2uxu4k268">
              Pescar más ya
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}